<app-page-container class="event-billing-container" [layoutType]="LayoutType.IntegratedTab" [tabConfig]="tabConfig" [title]="title" >
</app-page-container>
